



































































import { Component } from "vue-property-decorator";
import Vue from "vue";
import { placeModule } from "@/store/modules/place";
import { paramedicModule } from "@/store/modules/paramedic";
import { Account } from "@/types";
import { appModule } from "../store/modules/app";
import http from "@/http/axios";

@Component
export default class ParamedicList extends Vue {
  public search = "";
  public headers = [
    {
      text: "名稱",
      left: true,
      sortable: false,
      value: "name"
    },
    { text: "身份證字號", sortable: false, value: "iid" },
    { text: "性別", sortable: false, value: "gender" },
    { text: "年齡", sortable: false, value: "age" },
    { text: "生日", sortable: false, value: "birthday" },
    { text: "電話", sortable: false, value: "phone" },
    { text: "信箱", sortable: false, value: "email" },
    { text: "其他操作", value: "actions", sortable: false }
  ];
  public editDialog = false;
  public editItem = {
    age: 0,
    birthday: "",
    created_at: "",
    gender: "",
    health_state: 0,
    id: 0,
    iid: "",
    name: "",
    phone: "",
    updated_at: "",
    uuid: "",
    email: "",
    place: "",
    roles: [""]
  };

  get totalAccounts() {
    return paramedicModule.totalAccounts;
  }

  get place() {
    return placeModule.place;
  }

  get loading() {
    return paramedicModule.loading;
  }

  get accounts() {
    return paramedicModule.accounts;
  }

  get account() {
    return paramedicModule.account;
  }

  set account(item) {
    paramedicModule.setAccount(item);
  }

  async created() {
    await placeModule.placeList();
    await paramedicModule.accountList();
  }

  changeToPatient(item) {
    this.account = Object.assign({}, item);
    localStorage.setItem("accountName", item.name);
    this.$router.push({
      name: `負責個案`,
      params: { id: item.uuid }
    });
  }
  async edit(item: Account[]) {
    this.editDialog = true;
    this.editItem = JSON.parse(JSON.stringify(item));
    this.editItem.place = await placeModule.codetoPlace(item);
  }

  closeEdit() {
    this.editItem = {
      age: 0,
      birthday: "",
      created_at: "",
      gender: "",
      health_state: 0,
      id: 0,
      iid: "",
      name: "",
      phone: "",
      updated_at: "",
      uuid: "",
      email: "",
      place: "",
      roles: [""]
    };
    this.editDialog = false;
  }

  async saveEdit() {

    await placeModule.placetoCode(this.editItem);

    const params = {
      place: this.editItem.place,
    };

    const data = {
      uuid: this.editItem.uuid,
      params: params,
    };

    const result = await http.put("/user/" + this.editItem.uuid, params);
    if (result) {
      if (result.data.status === "Success") {
        appModule.sendSuccessNotice("修改成功");
      } else {
        appModule.sendErrorNotice("修改失敗");
      }
    } else {
      console.error(result.data.status);
    }
    this.closeEdit();
    await paramedicModule.accountList();
  }
}
